import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-alt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checklist = _resolveComponent("Checklist")!
  const _component_BaseHotspot = _resolveComponent("BaseHotspot")!

  return (_openBlock(), _createBlock(_component_BaseHotspot, {
    hotspotProgress: _ctx.hotspotProgress,
    showNext: _ctx.showNext,
    showPrevious: _ctx.showPrevious,
    onNextClick: _ctx.handleNextClick,
    onPreviousClick: _ctx.handlePreviousClick,
    onBackClick: _ctx.handleBackClick
  }, {
    nav: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "side-nav" }, null, -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.hotspotTitle), 1),
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.hotspotDescription), 1),
      _createVNode(_component_Checklist, {
        items: _ctx.checklistItems,
        actionable: false
      }, null, 8, ["items"])
    ]),
    _: 1
  }, 8, ["hotspotProgress", "showNext", "showPrevious", "onNextClick", "onPreviousClick", "onBackClick"]))
}